import React, { useContext } from 'react'
import { BuilderBlocks } from '@builder.io/react'
import CardContext from 'context/card'
import Title from './title'
import Tags from './tags'
import Description from './description'
import classNames from 'classnames'

const Body = () => {
    const {
        children,
        bodyStyle,
        bodyClassName,
    } = useContext(CardContext) 

    return(
        <div
            className={classNames('f-1 d-flex col g-4 a-start j-end', bodyClassName)}
            style={bodyStyle ? bodyStyle : { padding: '24px 20px' }}
        >
            <Title />
            <Description />
            {/* Button */}
            {children && <>
                {children.length ?
                    <BuilderBlocks blocks={children} /> :
                    children
                }
            </>}
        </div>
    )
}

export default Body